<template>
  <div
    v-show="!menuIsVerticalNavMini || (menuIsVerticalNavMini && isMouseHovered)"
    class="vertical-nav-menu-divider"
  >
    <div class="divider-line"></div>
  </div>
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'
import { inject } from '@vue/composition-api'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')

    return {
      menuIsVerticalNavMini,
      isMouseHovered,
    }
  },
}
</script>

<style lang="scss">
.vertical-nav-menu-divider {
  padding: 0 18px 0 22px;
  margin-top: 18px;
  height: 48px;
  display: flex;
  align-items: center;
  position: relative;

  .divider-line {
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgba(94, 86, 105, 0.14);
  }
}

.theme--dark .vertical-nav-menu-divider .divider-line {
  background-color: rgba(231, 227, 252, 0.14);
}
</style>

